<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
};

</script>

<style>
body{
  background: linear-gradient(192.2deg, rgba(143, 0, 191, 0.72) 12.73%, rgba(240, 216, 255, 0.114231) 80.94%, rgba(247, 223, 255, 0.72) 98.37%);

  background-size: cover;
  background-position: center;
  min-height: 100vh;
}
.nav{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav img {
  width: 400px;
}

.el-tabs {
  --el-tabs-header-height: 0px;
}
.el-tabs--right .el-tabs__content,
.el-tabs--left .el-tabs__content {
  height: 100%;
}
.el-dropdown-link {
  color: #720089;  
  border: 0px;
  background-color: rgba(0, 0,0 , 0);
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 1040px) {
  .nav img {
    width: 300px;
  }
  .summary-app-head {
    display: block;
  }
  .summary-text {
    margin: 0 auto;
    margin-bottom: 50px;
  }
  .summary-app-head h1{
    margin-top: 10%;
    color: #000;
  }
  .button-recharge{
    right: 12%;
  }
}


@media (max-width: 765px) {
  .nav img {
    width: 200px;
  }
  .summary-app-head h1{
    font-size: 30px;
  }
  .summary-app-head h2{
    font-size: 28px;
  }
  .el-button+.el-button {
    margin-left: 0;
  }
  .button-recharge{
    right: 18%;
  }
}

@media (max-width: 500px) {
  .nav img {
    width: 150px;
  }
  .summary-app-head h1{
    font-size: 20px;
  }
  .summary-app-head h2{
    font-size: 18px;
  }
  .button-recharge{
    width: 60px;
    font-size: 16px;
    right: 22%;
  }
}


</style>
@/store/loading